import { mapGetters } from "vuex";
export default {
  components: {},
  props: {},
  computed: {},
  methods: {
    /* EVENT TRACKING*/
    handleEventLog(data) {
      this.$emit("app-log", data);
    }
  },
  data() {
    return {};
  }
};
